import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import api from "@/lib/api";

const SESSION_KEY = "cs_session_id";
const SENT_KEY = "cs_analytics_last";

function getSessionId() {
  try {
    let sid = sessionStorage.getItem(SESSION_KEY);
    if (!sid) {
      sid = (crypto.randomUUID ? crypto.randomUUID() : String(Date.now()) + Math.random().toString(36).slice(2));
      sessionStorage.setItem(SESSION_KEY, sid);
    }
    return sid;
  } catch {
    return "anon-" + Date.now();
  }
}

function getUtm() {
  try {
    const u = new URLSearchParams(window.location.search);
    return {
      utm_source: u.get("utm_source") || "",
      utm_medium: u.get("utm_medium") || "",
      utm_campaign: u.get("utm_campaign") || "",
    };
  } catch {
    return { utm_source: "", utm_medium: "", utm_campaign: "" };
  }
}

export default function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname + (location.hash || "");
    // Skip admin & payment result pages
    if (path.startsWith("/admin") || path.startsWith("/payment/")) return;

    // Deduplicate double-fire in dev / rapid re-renders (2s window)
    try {
      const key = `${path}`;
      const last = sessionStorage.getItem(SENT_KEY);
      const parsed = last ? JSON.parse(last) : null;
      if (parsed && parsed.key === key && Date.now() - parsed.ts < 2000) return;
      sessionStorage.setItem(SENT_KEY, JSON.stringify({ key, ts: Date.now() }));
    } catch {
      /* noop */
    }

    const payload = {
      path,
      referrer: document.referrer || "",
      screen_w: window.innerWidth || null,
      screen_h: window.innerHeight || null,
      session_id: getSessionId(),
      ...getUtm(),
    };

    api.post("/analytics/track", payload).catch(() => { /* silent */ });
  }, [location.pathname, location.hash]);

  return null;
}
